export default __webpack_public_path__ + "74cec3e733f54c5ba26155de2aa22553.png";